"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import Api from "../../api/api";
import Address from "./address";
import CarrierService from "../../services/carrier_service";
import CustomerLoadsInformation from "./customer_loads_information";
import DropInformation from "./drop_information";
import generalFormatter from "../../formatters/general";
import get from "../data/get";
import HoverableValueTable from "../hoverable_value_table";
import { allReferences } from "../../helpers/references";
import ReactUtils from "../../react_utils";
import _ from "underscore";
import ValueTableItem from "./value_table_item";
import LoadLineItems, {
  LINE_ITEM_MODE__CARRIER,
  LINE_ITEM_MODE__SHIPMENTS,
  LINE_ITEM_MODE__SIDE_BY_SIDE
} from "./load_line_items";
import React from "react";
const bem = ReactUtils.makeBem("load-detail");
function renderBlindShipmentIcon() {
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsx("i", { className: `shipment-approval__flags__icon fi-check green` }),
    "\xA0TRUE"
  ] });
}
function shippedItemDisplay(shippedItem, index) {
  return /* @__PURE__ */ jsxs("tr", { children: [
    /* @__PURE__ */ jsx("td", { children: shippedItem.description }),
    /* @__PURE__ */ jsxs("td", { children: [
      shippedItem.weight,
      " ",
      shippedItem.weight_unit
    ] }),
    /* @__PURE__ */ jsx("td", { children: shippedItem.class_name }),
    /* @__PURE__ */ jsx("td", { children: shippedItem.quantity }),
    /* @__PURE__ */ jsx("td", { children: shippedItem.item_type }),
    /* @__PURE__ */ jsx("td", { children: shippedItem.length }),
    /* @__PURE__ */ jsx("td", { children: shippedItem.width }),
    /* @__PURE__ */ jsx("td", { children: shippedItem.height }),
    /* @__PURE__ */ jsx("td", { children: shippedItem.nmfc })
  ] }, "load_detail_data_row_" + index);
}
function noteDisplay(notes, note_type) {
  return /* @__PURE__ */ jsxs("span", { children: [
    /* @__PURE__ */ jsxs("strong", { children: [
      note_type,
      ":"
    ] }),
    "\xA0",
    notes.reduce((prev, curr) => [prev, /* @__PURE__ */ jsx("br", {}), curr])
  ] });
}
function valueTable(pairs, labelToolTipText) {
  var names = pairs.map((pair) => pair[0]);
  var values = pairs.map((pair) => pair[1]);
  var width = 100 / names.length + "%";
  return /* @__PURE__ */ jsxs("table", { className: "load-detail__info-table", children: [
    /* @__PURE__ */ jsx("thead", { children: /* @__PURE__ */ jsx("tr", { className: "load-detail__info-table-header", children: _.map(names, function(name) {
      if (labelToolTipText) {
        return /* @__PURE__ */ jsx(
          "th",
          {
            "data-tooltip": true,
            "aria-haspopup": "true",
            title: labelToolTipText,
            style: { width },
            children: name
          },
          name
        );
      } else {
        return /* @__PURE__ */ jsx("th", { style: { width }, children: name }, name);
      }
    }) }) }),
    /* @__PURE__ */ jsx("tbody", { children: /* @__PURE__ */ jsx("tr", { className: "load-detail__info-table-data", children: _.map(values, function(value, index) {
      return /* @__PURE__ */ jsx("td", { children: value }, "load_detail_info_value" + index);
    }) }) })
  ] });
}
function sideBySideLineItemsUxImprovementsEnabled() {
  return Api.Account.currentSettings().side_by_side_line_items_ux_improvements_enabled;
}
function carrierReferences(carrier) {
  const settings = Api.Account.currentSettings() || {};
  const reference_fields = settings.tms_carrier_visible_reference_fields || [];
  return _.map(reference_fields, function(field) {
    const value = carrier.references[field];
    return {
      name: field,
      value: value ? value : "-"
    };
  });
}
function carrierTable(carrierName, carrierReferences2) {
  if (carrierName) {
    const displayValues = [{ name: "Name", value: carrierName }].concat(
      carrierReferences2
    );
    const rows = _.map(displayValues, function(value) {
      return /* @__PURE__ */ jsxs(
        "div",
        {
          className: bem("__info-reference-pair"),
          children: [
            /* @__PURE__ */ jsxs("span", { className: bem("__info-reference-name"), children: [
              value.name,
              ":"
            ] }),
            /* @__PURE__ */ jsx("span", { className: bem("__info-reference-value"), children: value.value })
          ]
        },
        `shipment-reference-${value.name}`
      );
    });
    return /* @__PURE__ */ jsxs("table", { className: bem("__info-table", "__info-table-with-references"), children: [
      /* @__PURE__ */ jsx("thead", { children: /* @__PURE__ */ jsx("tr", { className: bem("__info-table-header"), children: /* @__PURE__ */ jsx("th", { children: "TMS Carrier" }) }) }),
      /* @__PURE__ */ jsx("tbody", { children: /* @__PURE__ */ jsx("tr", { children: /* @__PURE__ */ jsx("td", { className: bem("__info-with-references"), children: rows }) }) })
    ] });
  } else {
    return null;
  }
}
function renderLineItems(props, state, mode, condition) {
  if (condition) {
    return /* @__PURE__ */ jsx(
      LoadLineItems,
      {
        mode,
        load: props.load,
        invoice: props.invoice,
        lineItems: state.lineItems,
        lineItemsLoaded: state.lineItemsLoaded,
        lineItemCarriers: state.lineItemCarriers,
        shipments: state.shipments
      }
    );
  } else {
    return /* @__PURE__ */ jsx("div", {});
  }
}
function renderDistance(props, distance) {
  return /* @__PURE__ */ jsx(
    ValueTableItem,
    {
      onValueHighlighted: props.onTextToHighlightChanged,
      onValueClick: props.advanceableTextClicked,
      value: distance
    }
  );
}
function shippedItems(props) {
  const items = props.load.load.shipped_items;
  if (items.length > 0) {
    return /* @__PURE__ */ jsx("div", { className: "row", children: /* @__PURE__ */ jsx("div", { className: "small-10 column", children: /* @__PURE__ */ jsxs("div", { className: "load-detail__shipped-items", children: [
      /* @__PURE__ */ jsx("div", { className: "load-detail__shipped-item-table-title", children: /* @__PURE__ */ jsx("h4", { className: "load-detail__shipped-item-header", children: "Shipped Items" }) }),
      /* @__PURE__ */ jsxs("table", { className: "load-detail__info-table", children: [
        /* @__PURE__ */ jsx("thead", { children: /* @__PURE__ */ jsxs("tr", { className: "load-detail__info-table-header", children: [
          /* @__PURE__ */ jsx("th", { children: "Desc" }),
          /* @__PURE__ */ jsx("th", { children: "Wt" }),
          /* @__PURE__ */ jsx("th", { children: "Class name" }),
          /* @__PURE__ */ jsx("th", { children: "Qty" }),
          /* @__PURE__ */ jsx("th", { children: "Item type" }),
          /* @__PURE__ */ jsx("th", { children: "L" }),
          /* @__PURE__ */ jsx("th", { children: "W" }),
          /* @__PURE__ */ jsx("th", { children: "H" }),
          /* @__PURE__ */ jsx("th", { children: "NMFC" })
        ] }) }),
        /* @__PURE__ */ jsx("tbody", { children: _.map(items, (si, index) => {
          return shippedItemDisplay(si, index);
        }) })
      ] }, "shipped-items")
    ] }, "shipped-items") }) });
  }
}
function showFullNote(state, note_type) {
  return state[note_type];
}
function address(props, source, prefix) {
  return /* @__PURE__ */ jsx(
    Address,
    {
      onValueHighlighted: props.onTextToHighlightChanged,
      onValueClick: props.advanceableTextClicked,
      source,
      prefix
    }
  );
}
function addressInformation(props) {
  if (!Api.Account.currentSettings().prefer_shipment_location_data) {
    var load = props.load.load;
    var origin = address(props, load, "origin_");
    var destination = address(props, load, "destination_");
    var elements = [
      ["Origin", origin],
      ["Destination", destination]
    ];
    if (load.distance)
      elements.push(["Distance", renderDistance(props, load.distance)]);
    if (load.data.blind)
      elements.push(["Blind Shipment", renderBlindShipmentIcon()]);
    return /* @__PURE__ */ jsx("div", { className: "row", children: /* @__PURE__ */ jsx("div", { className: "small-10 column", children: valueTable(elements) }) });
  }
}
function referenceInformation(props) {
  const load = props.load.load;
  const references = allReferences(load);
  return /* @__PURE__ */ jsx("div", { className: "row", children: /* @__PURE__ */ jsx("div", { className: "small-10 column", children: /* @__PURE__ */ jsx(
    HoverableValueTable,
    {
      items: references,
      onValueHighlighted: props.onTextToHighlightChanged,
      onValueClick: props.advanceableTextClicked
    }
  ) }) });
}
function possibleMemo(props) {
  var memo = props.load.load.memo;
  if (memo) {
    return /* @__PURE__ */ jsx("div", { className: "row", children: /* @__PURE__ */ jsx("div", { className: "small-10 column", children: valueTable([["Memo", memo]]) }) });
  }
}
function carrierInformation(props) {
  if (!Api.Account.currentSettings().prefer_shipment_location_data) {
    var load = props.load.load;
    var shipped = load.actual_shipped_at ? generalFormatter.date(load.actual_shipped_at) : void 0;
    var delivered = load.actual_delivered_at ? generalFormatter.date(load.actual_delivered_at) : void 0;
    var carrierName = null;
    var carrierNotes = null;
    var references = [];
    if (load.carrier_id) {
      var carrier = CarrierService.getCarrierOrUnknown(load.carrier_id);
      carrierName = carrier.name;
      var customer_charge = load.customer_charge ? generalFormatter.currency(load.customer_charge) : void 0;
      carrierNotes = carrier.notes ? /* @__PURE__ */ jsx("div", { className: "small-10 column", children: valueTable([["Carrier Notes", carrier.notes]]) }) : "";
      references = carrierReferences(carrier);
    }
    return /* @__PURE__ */ jsxs("div", { className: "row load-detail__load-info-area", children: [
      /* @__PURE__ */ jsx("div", { className: "small-3 column load-detail__row-table-container-start", children: shipped ? valueTable([["Ship Date", shipped]]) : valueTable([["Ship Date", "-"]]) }),
      /* @__PURE__ */ jsx(
        "div",
        {
          className: "small-3 column load-detail__row-table-container" + (customer_charge ? "" : "-end"),
          children: delivered ? valueTable([["Delivered Date", delivered]]) : valueTable([["Delivered Date", "-"]])
        }
      ),
      /* @__PURE__ */ jsx(
        "div",
        {
          className: "small-4 column load-detail__row-table-container" + (customer_charge ? "-end" : ""),
          children: customer_charge ? valueTable([["Customer Charge", customer_charge]]) : ""
        }
      ),
      /* @__PURE__ */ jsx("div", { className: "small-10 column", children: carrierTable(carrierName, references) }),
      carrierNotes
    ] });
  }
}
function possibleDropInformation(props) {
  var drops = get.tmsDrops(props.load.load);
  var deliveries = get.tmsDropDeliveries(props.load.load);
  if (drops.length > 0 && deliveries.length > 0) {
    return /* @__PURE__ */ jsx(
      DropInformation,
      {
        load: props.load.load,
        onValueHighlighted: props.onTextToHighlightChanged,
        onValueClick: props.advanceableTextClicked
      }
    );
  }
}
function possibleCustomerLoadInformation(props) {
  const customerLoads = get.tmsCustomerLoads(props.load.load);
  if (customerLoads.length > 0) {
    return /* @__PURE__ */ jsx(CustomerLoadsInformation, { customerLoads });
  }
}
function initialState() {
  return {
    lineItemsLoaded: false,
    lineItems: [],
    lineItemCarriers: [],
    shipments: []
  };
}
class LoadDetailInformation extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", initialState());
    __publicField(this, "toggleShowFullNote", (note_type) => {
      const state = this.state;
      state[note_type] = !showFullNote(this.state, note_type);
      this.setState(state);
    });
    __publicField(this, "toggleFullNoteDisplay", (note_type) => {
      const text = showFullNote(this.state, note_type) ? "show less" : "show more";
      return /* @__PURE__ */ jsxs("span", { children: [
        /* @__PURE__ */ jsx("br", {}),
        /* @__PURE__ */ jsx("a", { onClick: () => this.toggleShowFullNote(note_type), children: text })
      ] });
    });
    __publicField(this, "possibleNoteDisplay", (note, note_type) => {
      const notes = note.split("\n");
      if (notes.length > 4) {
        if (!showFullNote(this.state, note_type)) {
          notes.splice(4);
        }
        return /* @__PURE__ */ jsxs("div", { children: [
          noteDisplay(notes, note_type),
          this.toggleFullNoteDisplay(note_type)
        ] });
      }
      return /* @__PURE__ */ jsx("div", { children: noteDisplay(notes, note_type) });
    });
    __publicField(this, "possibleLoadNoteDisplay", (load) => {
      if (load.data.load_note) {
        return this.possibleNoteDisplay(load.data.load_note, "Load Note");
      }
    });
    __publicField(this, "possibleSpecialInstructionsDisplay", (load) => {
      if (load.data.special_instructions) {
        return this.possibleNoteDisplay(
          load.data.special_instructions,
          "Special Instructions"
        );
      }
    });
    __publicField(this, "possiblePayablesNoteDisplay", (load) => {
      if (load.data.payables_note) {
        return this.possibleNoteDisplay(load.data.payables_note, "Payables Note");
      }
    });
    __publicField(this, "notesDisplay", (load) => {
      return /* @__PURE__ */ jsxs("div", { children: [
        this.possibleLoadNoteDisplay(load),
        this.possibleSpecialInstructionsDisplay(load),
        this.possiblePayablesNoteDisplay(load)
      ] });
    });
    __publicField(this, "possibleNotesFromLoad", () => {
      const load = this.props.load.load;
      if (load.data.load_note || load.data.special_instructions || load.data.payables_note) {
        return /* @__PURE__ */ jsx("div", { className: "small-10 column", children: valueTable([["Notes From Load", this.notesDisplay(load)]]) });
      }
    });
    __publicField(this, "loadLineItems", (props) => {
      const lineItems = props.load.load.line_items;
      const carrierIds = _.chain([
        lineItems,
        props.load.load.tms_carrier_payables
      ]).compact().flatten().pluck("tms_carrier_id").compact().unique().value();
      var carriers = _.map(carrierIds, (carrierId) => {
        return get.carrierById(carrierId);
      });
      const shipments = get.tmsShipments(props.load.load) || [];
      Promise.all(carriers).then((values) => {
        this.setState({
          lineItemsLoaded: true,
          lineItemCarriers: values,
          lineItems,
          shipments
        });
      });
    });
  }
  componentDidMount() {
    this.loadLineItems(this.props);
  }
  componentDidUpdate(prevProps) {
    if (this.props.load.id != prevProps.load.id) {
      this.setState(initialState());
      this.loadLineItems(this.props);
    }
  }
  render() {
    const isSideBySideLineItemsUxImprovementsEnabled = sideBySideLineItemsUxImprovementsEnabled();
    return /* @__PURE__ */ jsxs("div", { "data-component": "LoadDetailInformation", children: [
      /* @__PURE__ */ jsx("h3", { className: "load-detail__section-header load-detail__section-header__load-info", children: "Load Information" }),
      renderLineItems(
        this.props,
        this.state,
        LINE_ITEM_MODE__SIDE_BY_SIDE,
        isSideBySideLineItemsUxImprovementsEnabled
      ),
      addressInformation(this.props),
      possibleDropInformation(this.props),
      possibleCustomerLoadInformation(this.props),
      referenceInformation(this.props),
      possibleMemo(this.props),
      this.possibleNotesFromLoad(),
      carrierInformation(this.props),
      renderLineItems(
        this.props,
        this.state,
        LINE_ITEM_MODE__CARRIER,
        !isSideBySideLineItemsUxImprovementsEnabled
      ),
      renderLineItems(
        this.props,
        this.state,
        LINE_ITEM_MODE__SHIPMENTS,
        !isSideBySideLineItemsUxImprovementsEnabled
      ),
      shippedItems(this.props)
    ] });
  }
}
export default LoadDetailInformation;
